import { FaCrown, FaGooglePlay, FaTrophy } from "react-icons/fa";
import { RouteName } from "../route.utils";
import { socialLinks } from "../constants";

const awardsData = [
  {
    id: 1,
    title: "Google Play’s Best Apps of 2025",
    subtitle: "#2 in Top Trending Category",
    org: "Google Play",
    year: "2025",
    description:
      "Seekho was featured among Google Play’s Best Apps of 2025 and ranked #2 in the Top Trending category — a major milestone for product impact and user love.",
    icon: FaGooglePlay,
    badge: "Top Trending • #2",
    tone: "aurora",
    image:
      "https://images.seekhoapp.com/blog-image/0d3eeeee-4e4d-4042-bb74-6429cc17cd8a/original-content/911096bc-094b-48cb-abbc-62f7d379a63b.jpeg",
  },
  {
    id: 2,
    title: "Hurun India Future Unicorn Awards",
    subtitle: "Recognized as a Future Unicorn",
    org: "Hurun India",
    year: "2025",
    description:
      "Recognized by Hurun India for high-growth potential and category leadership, spotlighting Seekho as one of India’s promising Future Unicorns.",
    icon: FaTrophy,
    badge: "Future Unicorn",
    tone: "goldRush",
    image:
      "https://images.seekhoapp.com/blog-image/0d3eeeee-4e4d-4042-bb74-6429cc17cd8a/original-content/97fd73c8-b873-4213-ac6e-4b5a7548b961.jpeg",
  },
  {
    id: 3,
    title: "Avendus Wealth HURUN India’s 30 Under 30",
    subtitle: "Founder Recognition",
    org: "Hurun India × Avendus Wealth",
    year: "2025",
    description:
      "Our founder was honored in HURUN India’s 30 Under 30 list, celebrating young leaders shaping India’s next wave of innovation.",
    icon: FaCrown,
    badge: "30 Under 30",
    tone: "royalViolet",
    image: "/assets/teams/our-founders/our-founders.webp",
  },
  // {
  //   id: 4,
  //   title: "Avendus Wealth HURUN India’s 30 Under 30",
  //   subtitle: "Founder Recognition",
  //   org: "Hurun India × Avendus Wealth",
  //   year: "2024",
  //   description:
  //     "Our founder was honored in HURUN India’s 30 Under 30 list, celebrating young leaders shaping India’s next wave of innovation.",
  //   icon: FaCrown,
  //   badge: "30 Under 30",
  //   tone: "royalViolet",
  //   image:
  //     "https://seekho.in/_next/image?url=%2Fassets%2Fteams%2Four-founders%2Four-founders.webp&w=2048&q=75",
  // },
];

const toneStyles = {
  aurora: {
    ring: "ring-cyan-400/40",
    glow: "from-cyan-500/25 via-blue-500/10 to-fuchsia-500/25",
    chip: "bg-cyan-400/15 text-cyan-100 ring-cyan-300/30",
    iconBg: "bg-gradient-to-br from-cyan-500 to-blue-600",
  },
  goldRush: {
    ring: "ring-yellow-400/40",
    glow: "from-yellow-500/25 via-orange-500/10 to-rose-500/25",
    chip: "bg-yellow-300/15 text-yellow-50 ring-yellow-200/30",
    iconBg: "bg-gradient-to-br from-yellow-500 to-orange-600",
  },
  royalViolet: {
    ring: "ring-violet-400/40",
    glow: "from-violet-500/30 via-purple-500/10 to-fuchsia-500/30",
    chip: "bg-violet-400/15 text-violet-50 ring-violet-200/30",
    iconBg: "bg-gradient-to-br from-violet-500 to-fuchsia-600",
  },
};

const handleFallBackTheme = ({ index }) => {
  const hues = [
    "from-sky-300/35 via-cyan-200/20 to-transparent",
    "from-rose-300/35 via-amber-200/20 to-transparent",
    "from-purple-300/35 via-fuchsia-200/20 to-transparent",
    "from-teal-300/35 via-emerald-200/20 to-transparent",
  ];
  const frames = [
    "from-sky-200 via-cyan-200 to-blue-200",
    "from-rose-200 via-amber-200 to-orange-200",
    "from-purple-200 via-fuchsia-200 to-pink-200",
    "from-teal-200 via-emerald-200 to-lime-200",
  ];
  const h = index % hues.length;
  return {
    glow: hues[h],
    orbitGlow: hues[h],
    chip: "bg-white/10 text-white ring-white/20",
    ring: "ring-white/25",
    frame: frames[h],
    pageBg: "from-[#0b0d18] via-[#070812] to-[#05060a]",
    pageWash: "from-white/10 via-white/5 to-transparent",
  };
};

const structuredAwardData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `https://seekho.in`,
      name: "Seekho",
      sameAs: [
        socialLinks.facebook,
        socialLinks.instagram,
        socialLinks.linkedIn,
        socialLinks.youtube,
      ],
    },
    {
      "@type": "ItemList",
      "@id": RouteName.awardsAndRecognitions,
      name: "Seekho Awards & Recognitions",
      itemListOrder: "http://schema.org/ItemListOrderAscending",
      numberOfItems: awardsData.length,
      itemListElement: awardsData.map((award, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@type": "Award",
          name: award.title,
          alternateName: award.subtitle,
          description: award.description,
          awardedBy: {
            "@type": "Organization",
            "name:": award.org,
          },
          dateReceived: award.year,
          image: award.image,
          url: RouteName.awardsAndRecognitions,
        },
      })),
    },
  ],
};

export { awardsData, structuredAwardData, toneStyles, handleFallBackTheme };
